import React from 'react';
import PropTypes from 'prop-types';

function CreditCard({
    stroke = '#91A3BC',
    outerStroke = '#B0C9EB',
    fill = '#FFF',
    ...restProps
}) {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...restProps}
        >
            <defs>
                <clipPath id="clip0_1_734">
                    <rect width="32" height="32" rx="16" fill={fill} />
                </clipPath>
            </defs>
            <g clipPath="url(#clip0_1_734)">
                <rect width="32" height="32" rx="16" fill={fill} />
                <rect
                    x="7.5"
                    y="10.5"
                    width="17"
                    height="12"
                    rx="1.5"
                    stroke={stroke}
                />
                <path d="M8 14H25" stroke={stroke} strokeWidth="3" />
            </g>
            <rect
                x="0.5"
                y="0.5"
                width="31"
                height="31"
                rx="15.75"
                stroke={outerStroke || stroke}
            />
        </svg>
    );
}

CreditCard.propTypes = {
    fill: PropTypes.string,
    outerStroke: PropTypes.string,
    stroke: PropTypes.string,
};

export default CreditCard;
